"use client";

import { useEffect, useState } from "react";
import Slide1 from "./Slide1";
import Slide2 from "./Slide2";
import Slide3 from "./Slide3";
import Stats from "./Stats";
import HeroLeadForm from "./HeroLeadForm";

const slides = [<Slide1 />, <Slide2 />, <Slide3 />];

export default function Carousel() {
  const [index, setIndex] = useState(0);
  const [prevIndex, setPrevIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setPrevIndex(index);
      setIndex((prev) => (prev + 1) % slides.length);
    }, 4000);

    return () => clearInterval(interval);
  }, [index]);

  return (
    <section className="w-full overflow-hidden">
      <div className="w-full">
        <div className="grid grid-cols-1 overflow-hidden lg:grid-cols-[7fr_3fr] lg:bg-white lg:shadow-[0_20px_80px_rgba(13,111,234,0.12)]">
          <div className="relative h-[862px] overflow-hidden lg:h-[504px]">
            {slides.map((slide, i) => {
              const isActive = i === index;
              const isPrev = i === prevIndex;

              return (
                <div
                  key={i}
                  className={`absolute inset-0 h-full w-full transition-transform duration-700 ease-in-out ${
                    isActive
                      ? "translate-x-0 z-2"
                      : isPrev
                      ? "-translate-x-full z-2"
                      : "translate-x-full z-0"
                  }`}
                >
                  {slide}
                </div>
              );
            })}

            <div className="hidden lg:flex absolute left-[32px] top-1/2 -translate-y-1/2 flex-col gap-[4px] z-5">
              {slides.map((_, i) => (
                <div
                  key={i}
                  className={`h-10 w-[0.9px] transition-all duration-500 ${
                    i === index ? "bg-white" : "bg-[#7f7f7f]"
                  }`}
                />
              ))}
            </div>
          </div>

          <div className="hidden lg:flex h-[504px] items-center justify-center bg-[#0d6fea] p-6">
            <HeroLeadForm />
          </div>
        </div>
      </div>

      <div className="flex lg:hidden justify-center gap-[8px] mt-[24px] md:mt-[15px]">
        {slides.map((_, i) => (
          <div
            key={i}
            className={`h-[1px] w-10 transition-all duration-500 rounded-full ${
              i === index ? "bg-[#222222]" : "bg-[#e9e9e9]"
            }`}
          />
        ))}
      </div>

      <div className="mt-8 px-4 lg:hidden">
        <HeroLeadForm />
      </div>

      <div className="mt-10 h-[80px]">
        <Stats />
      </div>
    </section>
  );
}
